module.exports = __webpack_public_path__ + "static/media/upload-document-anyotherpaper-desktop.b862e65a.png";